import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Header from "../../../components/Header";

const ExamInstructions = () => {
  const navigate = useNavigate();
  const profile = JSON.parse(localStorage.getItem("profile")) || {};
  const examConfig = JSON.parse(sessionStorage.getItem("examConfig")) || {};
  const testTitle = examConfig?.testName;

  return (
    <div className="flex flex-col h-screen bg-[#F5F7FA] font-sans text-[#333]">
      <Header testTitle={testTitle} />
      {/* 2. MAIN CONTENT WRAPPER */}
      <div className="flex flex-1 overflow-hidden w-full max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row w-full h-full">
          <div className="order-1 lg:order-2 w-full lg:w-[380px] bg-[#F5F8FA] lg:border-l border-b lg:border-b-0 border-[#E0E0E0] py-6 lg:pt-10 flex flex-col items-center shrink-0">
            <div className="w-[100px] h-[100px] lg:w-[120px] lg:h-[120px] rounded-full overflow-hidden shadow-sm mb-4 border-[3px] border-white">
              {profile?.user?.image ? (
                <img
                  src={profile.user.image}
                  alt="Candidate"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-[40px] lg:text-[50px] font-bold">
                  {profile?.user?.name
                    ? profile.user.name.charAt(0).toUpperCase()
                    : "C"}
                </span>
              )}
            </div>
            <h3 className="text-[20px] lg:text-[22px] font-[500] text-[#000000] tracking-tight">
              {profile?.user?.name || "Candidate"}
            </h3>
          </div>

          {/*LEFT SIDE*/}
          <div className="order-2 lg:order-1 flex-1 overflow-y-auto p-5 md:p-8 mt-8 scrollbar-thin">
            <h2 className="text-[22px] font-[500] text-[#333333] font-inter mb-4 tracking-tight ">
              General Instructions:
            </h2>
            <div className="space-y-4 text-[18px] font-[500]  leading-tight tracking-tight text-[#333333] font-inter">
              <p>
                1. The clock will be set at the server. The countdown timer at
                the top right corner of screen will display the remaining time
                available for you to complete the examination. When the timer
                reaches zero, the examination will end by itself. You need not
                terminate the examination or submit your paper.
              </p>
              <p>
                2. The Question Palette displayed on the right side of screen
                will show the status of each question using one of the following
                symbols:
              </p>
              {/* Legend Box */}
              <div className=" space-y-3 mt-4 mb-6 text-[18px] font-[500] text-[#333333] font-inter leading-tight tracking-tight">
                <div className="flex items-center gap-3">
                  <div className="w-[22px] h-[22px] border border-[#33333399] rounded-[3px]"></div>
                  <span>You have not visited the question yet.</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-[22px] h-[22px] rounded-[3px] bg-[#E63946]"></div>
                  <span>You have not answered the question.</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-[22px] h-[22px] rounded-[3px] bg-[#21C11E]"></div>
                  <span>You have answered the question.</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-[22px] h-[22px] rounded-[3px] bg-[#FA6400]"></div>
                  <span>
                    You have NOT answered the question, but have marked the
                    question for review.
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-[22px] h-[22px] rounded-[3px] bg-[#FA6400] relative"></div>
                  <span>
                    You have answered the question, but marked it for review.
                  </span>
                </div>
              </div>

              <p className="text-[18px] font-[500] text-[#333333] font-inter tracking-tight">
                The Mark For Review status for a question simply indicates that
                you would like to look at that question again. If a question is
                answered, but marked for review, then the answer will be
                considered for evaluation unless the status is modified by the
                candidate.
              </p>

              {/* Navigation Section */}
              <div className=" space-y-5 mt-4 mb-6 text-[18px] font-[500] text-[#333333] font-inter leading-tight tracking-tight">
                <h3 className="text-[22px] font-[600]  font-inter tracking-tight mt-6 mb-5">
                  Navigating to a Question :
                </h3>
                <p className="font-[600] text-[18px]">
                  3. To answer a question, do the following:
                </p>
                <ol className="list-decimal ml-6">
                  <li>
                    Click on the question number in the Question Palette at the
                    right of your screen to go to that numbered question
                    directly. Note that using this option does NOT save your
                    answer to the current question.
                  </li>
                  <li>
                    Click on <strong>Save & Next</strong> to save your answer
                    for the current question and then go to the next question.
                  </li>
                  <li>
                    Click on <strong>Mark for Review & Next</strong> to save
                    your answer for the current question and also mark it for
                    review, and then go to the next question.
                  </li>
                </ol>
                <p className="mt-2">
                  Note that your answer for the current question will not be
                  saved, if you navigate to another question directly by
                  clicking on a question number without saving the answer to the
                  previous question.
                </p>

                <p className="mt-2">
                  You can view all the questions by clicking on the Question
                  Paper button.
                  <span className="text-[#DC2626]">
                    {" "}
                    This feature is provided, so that if you want you can just
                    see the entire question paper at a glance.
                  </span>
                </p>

                {/* Answering Section */}
                <h3 className="text-[22px]  font-[600]  font-inter tracking-tight mt-6 mb-5">
                  Answering a Question :
                </h3>
                <p className="font-[600] text-[18px]">
                  4. Procedure for answering a multiple choice (MCQ) type
                  question:
                </p>
                <ol className="list-decimal ml-6 ">
                  <li>
                    Choose one answer from the 4 options (A,B,C,D) given below
                    the question, click on the bubble placed before the chosen
                    option.
                  </li>
                  <li>
                    To deselect your chosen answer, click on the bubble of the
                    chosen option again or click on the{" "}
                    <strong>Clear Response</strong> button.
                  </li>
                  <li>
                    To change your chosen answer, click on the bubble of another
                    option.
                  </li>
                  <li>
                    To save your answer, you MUST click on the{" "}
                    <strong>Save & Next</strong> button.
                  </li>
                </ol>

                <h3 className="text-[22px] font-[600]  font-inter tracking-tight mt-6 mb-5">
                  5. Procedure for answering a numerical answer type question :
                </h3>
                <ol className="list-decimal ml-6 leading-tight tracking-tight font-[500] text-[18px]">
                  <li>
                    To enter a number as your answer, use the virtual numerical
                    keypad.
                  </li>
                  <li>
                    A fraction (e.g. -0.3 or -.3) can be entered as an answer
                    with or without "0" before the decimal point.{" "}
                    <span className="text-[#DC2626]">
                      As many as four decimal points, e.g. 12.5435 or 0.003 or
                      -932.6711 or 12.82 can be entered.
                    </span>
                  </li>
                  <li>
                    To clear your answer, click on the{" "}
                    <strong>Clear Response</strong> button.
                  </li>
                  <li>
                    To save your answer, you MUST click on the{" "}
                    <strong>Save & Next</strong> button.
                  </li>
                </ol>

                <p className="mt-1">
                  6. To mark a question for review, click on the{" "}
                  <strong>Mark for Review & Next</strong> button. If an answer
                  is selected (for MCQ/MCAQ) entered (for numerical answer type)
                  for a question that is Marked for Review, that answer will be
                  considered in the evaluation unless the status is modified by
                  the candidate.
                </p>
                <p className="mt-1">
                  7. To change your answer to a question that has already been
                  answered, first select that question for answering and then
                  follow the procedure for answering that type of question.
                </p>
                <p className="mt-1">
                  8. Note that ONLY Questions for which answers are saved or
                  marked for review after answering will be considered for
                  evaluation.
                </p>
                <p className="mt-1">
                  9. Sections in this question paper are displayed on the top
                  bar of the screen. Questions in a Section can be viewed by
                  clicking on the name of that Section. The Section you are
                  currently viewing will be highlighted.
                </p>
                <p className="mt-1">
                  10. After clicking the Save & Next button for the last
                  question in a Section, you will automatically be taken to the
                  first question of the next Section in sequence.
                </p>
                <p className="mt-1">
                  11. You can move the mouse cursor over the name of a Section
                  to view the answering status for that Section.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 3. FOOTER */}
      <footer className="h-[86px] shadow-[0_-2px_4px_rgba(0,0,0,0.25)]  bg-white sticky bottom-0 z-10 w-full ">
        <div className="w-full px-3 md:px-0 max-w-[1400px] mx-auto h-full flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#333333] font-[500] text-[22px] transition-colors cursor-pointer"
          >
            <FiArrowLeft size={22} className="font-[500]" />
            Go to Tests
          </button>

          <button
            onClick={() =>
              navigate("/test-instructions")
            }
            className="bg-[#4096F6] hover:bg-[#2563EB] cursor-pointer text-white px-10 py-[7px] rounded-[3px] font-[500] text-[22px] shadow-sm transition-colors"
          >
            Next
          </button>
        </div>
      </footer>
    </div>
  );
};

export default ExamInstructions;
